import React, {useState, useEffect} from 'react';
import { useRoutes, Routes, Route, HashRouter as Router } from 'react-router-dom';
import Home from './Home';
import Home2 from './Home2';
import HomeHorizontal from './HomeHorizontal'
import CadastrarPalavra from './CadastrarPalavra';
import Cristocurasim from './Cristocurasim';


const App = () => {

  const [windowSize, setWindowSize] = useState({
          width: window.innerWidth,
          height: window.innerHeight,
      });

      useEffect(() => {
              const handleResize = () => {
                  setWindowSize({
                      width: window.innerWidth,
                      height: window.innerHeight,
                  });
              };
      
              // Adiciona o listener de resize
              window.addEventListener('resize', handleResize);
      
              // Remove o listener ao desmontar o componente
              return () => window.removeEventListener('resize', handleResize);
          }, []);
      

    return(
//    <Router>
    <Routes>
        <Route path="/" element={<Home2 />} />
        {/* <Route path="/" element={windowSize.width > windowSize.height ? <HomeHorizontal /> : <Home />} /> */}
        <Route path="/palavra" element={<CadastrarPalavra />} />
        <Route path="/cristocurasim" element={<Cristocurasim />} />
        {/* <Route path="/cadastrar" element={<Home />} />
        <Route path="/doadores" element={<About /> } />
        <Route path="/doacoes" element={<Doacoes /> } /> */}
  {/* let routes = useRoutes([
    { path: '/cadastrar', element: <Home /> },
    { path: '/doadores', element: <About /> },
  ]); */}
  </Routes>
//    </Router>
    )
//   return routes;
};

export default App;